(function (ws) {
    'use strict';
    ws.views.packingSlipPdfModal = ws.views.modal.extend({
        /** TODO: Refactor this to be in common components and to accept any PDF. **/
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);
            this.$packingSlipPdfObject = this.$('#packing-slip-pdf');
            this.$forceDownloadError = $('.force-download-error');
            this.$forcedLink = $('.forced-link');
            this.hidePdfElementIfNeeded();
        },

        /**
         * If the user is using IE we have to show a message about pdf view support
         */
        hidePdfElementIfNeeded () {
            if (this.isIEBrowser()) {
                this.$forceDownloadError.show();
                this.$packingSlipPdfObject.hide();
            }
        },

        /**
         *  Check if the browser is IE.
         */
        isIEBrowser () {
            return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
        },

        /**
         * Overriding onOpen and setting url for pdf object
         *
         @param {Object} ev
         */
        onOpen (ev) {
            const packingSlipPdfUrl = $(ev.currentTarget).data('packing-slip-url');
            this.changeTemplate(packingSlipPdfUrl);
            ws.views.modal.prototype.onOpen.call(this, ev);

            if (this.isIEBrowser()) {
                this.$forcedLink.attr('href', packingSlipPdfUrl);
            }
        },

        /*
         * Template for Object tag to load the different pdf
         */
        changeTemplate: function(url) {
            var pdfTemplate = this.$('#packing-slip-pdf');
            pdfTemplate.html('');
            pdfTemplate.html('<object type="application/pdf" width="100%" height="100%" data="' + url + '"></object>');
        }
    });
})(westcon);
